export default `
    <div id="#= data.containerId #" class="#= data.containerClasses || "" # #=data.bsc||""#">
        <div id="#= data.searchContainerId #" class="#= data.searchClasses || "" # search-contents container">
            <div id="#=data.searchContainerId#_Actions" class="button-column">
            </div>
        </div>
        <div id="#= data.id #" class="chart #= data.classes || "" #" style="width: auto"></div>
        </div>
    </div>
`;
